<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';
import { buildWhatsAppUrl } from '../utils/agendaQuickActions';

const props = defineProps({
  contact: { type: Object, required: true },
  message: { type: String, default: '' },
});

const phoneHref = computed(() =>
  props.contact.phone ? `tel:${props.contact.phone}` : ''
);
const whatsappHref = computed(() =>
  buildWhatsAppUrl({
    phone: props.contact.phone,
    message: props.message || `Olá, ${props.contact.name}!`,
  })
);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <article
    class="grid gap-3 rounded-lais-sm border border-lais-border bg-white px-4 py-3"
  >
    <div class="flex items-start justify-between gap-3">
      <div class="min-w-0">
        <p class="truncate text-[14px] font-semibold text-lais-text">
          {{ contact.name }}
        </p>
        <p class="mt-0.5 text-[12px] text-lais-text-muted">
          {{ contact.roleLabel }}
        </p>
      </div>
      <span
        v-if="contact.isListingRepresentative"
        class="rounded-full bg-lais-primary-50 px-2 py-1 text-[11px] font-semibold text-lais-primary"
      >
        LR
      </span>
    </div>

    <p class="min-h-5 text-[13px] text-lais-text-body">
      {{ contact.phone || contact.email || 'Contato protegido' }}
    </p>

    <div class="grid grid-cols-2 gap-2">
      <a
        :href="phoneHref || undefined"
        class="inline-flex min-h-9 items-center justify-center gap-2 rounded-lais-sm border border-lais-border px-3 text-[12px] font-semibold transition-colors"
        :class="
          phoneHref
            ? 'bg-white text-lais-text hover:border-lais-primary hover:text-lais-primary'
            : 'pointer-events-none bg-lais-bg-soft text-lais-text-muted'
        "
      >
        <span class="i-lucide-phone size-3.5" aria-hidden="true" />
        Ligar
      </a>
      <a
        :href="whatsappHref || undefined"
        target="_blank"
        rel="noopener noreferrer"
        class="inline-flex min-h-9 items-center justify-center gap-2 rounded-lais-sm px-3 text-[12px] font-semibold transition-colors"
        :class="
          whatsappHref
            ? 'bg-lais-primary text-white hover:bg-lais-primary/90'
            : 'pointer-events-none bg-lais-bg-soft text-lais-text-muted'
        "
      >
        <span class="i-lucide-message-circle size-3.5" aria-hidden="true" />
        Mensagem
      </a>
    </div>
  </article>
</template>
